import { BellRing, MapPin, MessageCircle } from "lucide-react";

interface MobileAppsSectionProps {
  className?: string;
}

export default function MobileAppsSection({
  className = "",
}: MobileAppsSectionProps) {
  return (
    <section
      className={`px-4 py-16 bg-gradient-to-r from-[#215E60]/5 to-[#E06448]/5 ${className}`}
    >
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-midnight-blue">
          Có Mẹ Ở Đâu, Con Cũng An Toàn
        </h2>
        <p className="text-lg text-midnight-blue/80 mb-12 max-w-2xl mx-auto">
          Luôn bên cạnh con dù mẹ đang ở công ty, đi chợ, hay bận việc nhà. Ứng
          dụng Locuno giúp mẹ kết nối với con 24/7, chỉ với một chiếc điện thoại
          trong túi.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
          <a
            href="https://apps.apple.com/vn/app/locuno/id6753800628"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105 hover:shadow-lg"
          >
            <img
              src="/images/appstore.png"
              alt="Download on App Store"
              className="h-16 w-auto"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.locunoapp"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105 hover:shadow-lg"
          >
            <img
              src="/images/playstore.png"
              alt="Get it on Google Play"
              className="h-16 w-auto"
            />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-midnight-blue/70">
          <div className="flex items-center justify-center gap-2">
            <BellRing className="w-4 h-4 text-green-600" />
            <span>Thông báo realtime</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <MessageCircle className="w-4 h-4 text-blue-600" />
            <span>Chat nhanh chóng</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <MapPin className="w-4 h-4 text-purple-600" />
            <span>Bản đồ tương tác</span>
          </div>
        </div>
      </div>
    </section>
  );
}
